let RE = {
    game:'Piroker',

    time: 0,  //时间戳

    language: 'TW',    //语言

    os: null,       //操作系统

    url: '',  //跳转地址
    iosUrl: 'https://apps.apple.com/cn/app/%E5%86%92%E9%99%A9%E8%80%85%E6%97%A5%E8%AE%B0/id6532613907',  //默认地址
    AndUrl: 'https://cncapybarago.habbygame.cn/',  //默认地址

    h: 'https://www.xiaohongshu.com/user/profile/653472b1000000000301e6ac?xhsshare=CopyLink&appuid=653472b1000000000301e6ac&apptime=1730096764&share_id=7453f91384124738a0b7ed062cbba5c1',
    d: 'https://v.douyin.com/iSXATEXh',
}
// 1. 10w，2024/11/08
// 2. 30w，2024/11/11
// 3. 50w，2024/11/18
// 4. 100w，2024/11/22
// 5. 200w，2024/12/02

let year = new Date().getFullYear();
let month = new Date().getMonth() + 1;
let day = new Date().getDate();

if (year > 2024){
    RE.time = 5;
} else {
    if (month > 11){
        RE.time = 5;
    } else if (month == 11) {
        if(day > 21){
            RE.time = 4;
        } else if(day > 17){
            RE.time = 3;
        } else if(day > 10){
            RE.time = 2;
        } else if(day > 7){
            RE.time = 1;
        } else {
            RE.time = 0;
        }
    } 
}
// console.log(RE, 'RE');

module.exports = RE;



// WEBPACK FOOTER //
// ./src/assets/replace.js